export enum FeatureFlags {
  RobinhoodServiceEnabled = 'robinhood-service-enabled',
  FlowIdByAction = 'tools-flow-id-by-action',
  ShouldRunIncidentManagementService = 'tools-should-run-incident-management-service',
  ShouldCalculateIncidentManagementService = 'tools-should-calculate-incident-management-service',
  ShouldShowSubscriptionTimeline = 'tools-should-show-subscription-timeline',
  ShouldAllowSwitchFirmToSmb = 'tools-should-allow-switch-firm-to-smb',
  ShouldDisplayMultihitFeature = 'should-display-multihit-feature',
  ShouldWriteMultihitFeature = 'should-write-multihit-feature',
  ShouldEnableRfiForOrg = 'tools-should-enable-rfi-for-org',
  SherlockAllowOtherEddComplianceRejectionLabel = 'sherlock-allow-other-edd-compliance-rejection-label',
  ShouldShowEntityViewer = 'tools-should-show-entity-viewer',
  ShouldDisplayNewMmFeatures = 'tools-should-display-new-mm-features',
  ShouldHidePphTabs = 'tools-should-hide-pph-tabs',
  ShouldDisplayAgentSuggestions = 'risk-should-display-agent-suggestions',
  EnableMultihitV1 = 'tools-enable-multihit-v1',
  ToolsRfiConfirmedPartnerConfig = 'tools-rfi-confirmed-partner-config',
  ShouldCreateLimitationTasks = 'tools-should-create-limitation-tasks',
  ShouldPreventCreateEddTaskOnCrrCalculated = 'tools-should-prevent-create-edd-task-on-crr-calculated',
  ToolsShouldDisplayCashAdvancedAgentResponse = 'tools-should-display-cash-advanced-agent-response',
  ToolsShouldDisplaySfAgentResponse = 'tools-should-display-sf-agent-response',
  ToolsShouldDisplayKybNullAgentResponse = 'tools-should-display-kyb-null-agent-response',
  ReconServiceShouldShowCheckReconcileFloatingButton = 'recon-service-should-show-check-reconcile-floating-button',
  ToolsShouldDisplayDMCreatorEmail = 'tools-should-display-dm-creator-email',
  ShouldDisplayUserEventTab = 'tools-should-display-user-event-tab',
  ShouldDisplayAuditLogTab = 'tools-should-display-audit-log-tab',
  MosEgressEmailXeroDomain = 'mos-egress-email-xero-domain',
  ShouldHideCsomSystemDecisions = 'tools-should-hide-csom-system-decisions',
  ToolsShouldUseTruliooKycVendor = 'tools-should-use-trulioo-kyc-vendor',
  ToolsEnableDataLoaderCache = 'tools-enable-data-loader-cache',
  ToolsShouldHideCddLabel = 'tools-should-hide-cdd-label',
  ShouldShowRiskNotificationViewDetails = 'tools-should-show-risk-notification-view-details'
}
